<template>
  <div class="mb-2">
    <label
        for="pos-print"
        class="form-label"
    >
      Pos Print Size(MM)
    </label>
    <input
        type="number"
        class="form-control width-20-per"
        id="pos-print"
        v-model="posPrintSize"
        @change="handlePosPrintSizeChange"
    >
  </div>

    <GlobalLoader />
</template>

<script setup>
import {inject, onMounted, ref} from "vue";
    import handleCompany from "@/services/modules/company";
    import GlobalLoader from "@/components/atom/GlobalLoader.vue";
    import {useStore} from "vuex";
    import {useRoute} from "vue-router";

    const posPrintSize = ref(null)
    const { getCompanyPreferences, modifyCompanyPreference } = handleCompany();
    const $store = useStore();
    const $route = useRoute();
    const showSuccess =  inject('showSuccess');
    const companyId = $route.params.companyId;

    const handlePosPrintSizeChange = (e) => {
        const nextValue = e.target.value;

        const data = {
            company_id: companyId,
            field: "pos_print_size",
            value: nextValue,
        };

        handleUpdate(data);
    }

    const handleUpdate = (data) => {
        $store.state.loading = true;

        modifyCompanyPreference(data)
            .then((res) => {
                showSuccess(res.message);
            })
            .finally(() => ($store.state.loading = false));
    }

    const getInitialValue = (data, field) => {
        const item = data.find((item => item.field === field))

        return item ? item.value : null;
    }

    onMounted(() => {
        $store.state.loading = true

        const queryObject = {
            company_id: companyId,
            fields: 'pos_print_size'
        }
        const query = '?' + new URLSearchParams(queryObject).toString();

        getCompanyPreferences(query)
            .then(res => {
              if (res.data){
                const data = res.data;
                posPrintSize.value = getInitialValue(data, 'pos_print_size')
              }
            })
            .finally(() => $store.state.loading = false);
    });
</script>